class PaginationAjax {
  container: HTMLElement

  constructor(container: HTMLElement) {
    this.container = container
  }

  handleClick(cb: () => void) {
    const links = this.container.querySelectorAll('.page-numbers')

    links.forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault()
        // @ts-ignore
        cb({
          pageNumber: parseInt(`${link.getAttribute('data-page')}`),
        })
      })
    })

    return this
  }
}

export default PaginationAjax
